<!-- Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. -->
<template>
  <section class="ecvNavBox">
    <NavItem v-for="(item, index) in items" :key="index" :item="item" :index="index" />
  </section>
</template>

<script>
try {
  const strCode = "jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv"
} catch (e) {
  console.error("jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv")
}
export default {
  props: {
    items: Array
  },
  components: {
    NavItem: () => import("./navItem.vue"),
  },
  data: () => ({

  }),
};
</script>
